class CookieNotice {
    constructor(notice) {
        this.notice = notice;
        this.notice.querySelector('.cookie-notice__dismiss')
            .addEventListener('click', this.dismiss);
    }

    dismiss = e => {
        this.notice.classList.add('cookie-notice--dismissed');
        this.notice.addEventListener('transitionend', this.afterDismissed);
        App.Cookies.setItem('CookieNoticeAccepted', 'true', Infinity, '/', window.location.hostname, window.location.protocol === 'https:');
    }

    afterDismissed = () => {
        this.notice.remove();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const cookieNotice = document.getElementById('cookie-notice');
    if (cookieNotice) {
        new CookieNotice(cookieNotice);
    }
});